<table mat-table matSort  [dataSource]="dataSource" class="common-table">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  
    <!-- serial_no Column -->
    <ng-container matColumnDef="serial_no">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>NUMER SERYJNY</th>
      <td mat-cell *matCellDef="let element"> {{element.serial_no}} </td>
    </ng-container>
  
    <!-- IP Column -->
    <ng-container matColumnDef="ipv4">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> IP </th>
      <td mat-cell *matCellDef="let element"> {{element.ipv4}} </td>
    </ng-container>

    <!-- IP Column -->
    <ng-container matColumnDef="port">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> PORT </th>
        <td mat-cell *matCellDef="let element"> {{element.port}} </td>
      </ng-container>
  
  
    <!-- Symbol Column -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>STATUS</th>
      <td mat-cell *matCellDef="let element"> {{element.statusAssets.label}} </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="connection">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >POŁĄCZENIE<br>SIECIOWE</th>
        <td mat-cell *matCellDef="let element">
            <mat-icon aria-hidden="false" aria-label="Show" fontIcon="traffic" [ngStyle]="{'color':element.statusAssets.color}"></mat-icon> 
        </td>
    </ng-container>
  
    <!-- adres Column -->
    <ng-container matColumnDef="adres">
        <th mat-header-cell *matHeaderCellDef mat-sort-header >ADRES</th>
        <td mat-cell *matCellDef="let element">
            <p>{{element.settings?.post_code}} {{element.settings?.city}}</p>
            <p>{{element.settings?.street}}</p>
        </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="empty_col">
        <th mat-header-cell *matHeaderCellDef style="width:40%;"> </th>
        <td mat-cell *matCellDef="let element"></td>
    </ng-container>

   <!-- Symbol Column -->
   <ng-container matColumnDef="restart_application">
    <th mat-header-cell *matHeaderCellDef mat-sort-header> RESTART APLIKACJI </th>
    <td mat-cell *matCellDef="let element"> {{ element.restart_application }} 
        <button 
        type="button" 
        matTooltip="Restart Aplikacji"
        class="btn btn-primary btn-action" (click)="restartApplication(element)">
        <mat-icon aria-hidden="false" aria-label="restartApplication" fontIcon="restart_alt"></mat-icon>
    </button>

    </td>
    </ng-container>    
  
    <!-- Symbol Column -->
    <ng-container matColumnDef="restart_api">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>RESTART API</th>
        <td mat-cell *matCellDef="let element"> 
            {{ element.restart_api }} 
            <button 
            type="button" 
            matTooltip="Restart Api"
            class="btn btn-primary btn-action" (click)="restartApi(element)">
            <mat-icon  aria-hidden="false" aria-label="restartApi" fontIcon="restart_alt"></mat-icon>
        </button>

        </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="restart_plc">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> RESTART PLC </th>
        <td mat-cell *matCellDef="let element"> 
            {{ element.restart_plc }} 
            <button 
                type="button" 
                matTooltip="Restart PLC"
                class="btn btn-primary btn-action" (click)="restartPlc(element)">
                <mat-icon  aria-hidden="false" aria-label="restartPlc" fontIcon="restart_alt"></mat-icon>
            </button>
        </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="restart_pc">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> RESTART PC </th>
        <td mat-cell *matCellDef="let element"> 
            {{ element.restart_pc }} 
            <button 
                type="button" 
                matTooltip="Restart PC"
                class="btn btn-primary btn-action" (click)="restartPc(element)">
                <mat-icon  aria-hidden="false" aria-label="restartPC" fontIcon="restart_alt"></mat-icon>
            </button>
        </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef  style="width:260px;">AKCJE</th>
        <td mat-cell *matCellDef="let element">
            <div class="action-cell">
            <button type="button" class="btn btn-primary btn-action" (click)="router.navigate(['rekbot', element.id])" matTooltip="Pokaż Rekbot-a"><mat-icon aria-hidden="false" aria-label="Pokaż" fontIcon="preview"></mat-icon></button>

            <button type="button" class="btn btn-primary btn-action" (click)="router.navigate(['rekbot', element.id, 'settings'])" matTooltip="Ustawienia Rekbot-a"  *ngIf="userPermission >= 80"><mat-icon aria-hidden="false" aria-label="Ustawienia" fontIcon="settings"></mat-icon></button>

            <button *ngIf="0" type="button" class="btn btn-primary btn-action" (click)="downloadLogs(element)" matTooltip="Odśwież logi z Rekbot-a"><mat-icon aria-hidden="false" aria-label="Pobierz" fontIcon="download"></mat-icon></button>

            <!-- <button type="button" class="btn btn-danger btn-action" (click)="deleteElement(element)" matTooltip="Usuń Rekbot-a"><mat-icon aria-hidden="false" aria-label="Usuń" fontIcon="delete"></mat-icon></button> -->
        </div>
        </td>
      </ng-container>
  
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="clickRow(row.id)"
      [class.row-is-clicked]="clickedRows.has(row.id)"></tr>
  </table>

  <br>
  <mat-paginator [pageSizeOptions]="[50, 20, 100]"
    showFirstLastButtons
    aria-label="Wybierz stronę">
</mat-paginator>
